<i class="fa fa-question-circle" (click)="openHelp()" [ngStyle]="{'color': color}"></i>
